export default __webpack_public_path__ + "static/media/faq-2.d59abb78.png";